import { styles as libraryStyles } from "components/Tools/LibraryModal/styles/LibraryModal.styles"
import {
  largeWidthBreakPoint,
  maxWidth600,
  minWidth1200,
  minWidth1500,
} from "themes/default/breakpoints"

export const styles = {
  container: (theme) => ({
    ...libraryStyles.container,

    maxHeight: "95vh",
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.background.main,
    [maxWidth600]: {
      p: 0,
    },
    [minWidth1500]: {
      maxWidth: "80%",
    },
  }),
  containerExerciseExplanation: {
    maxWidth: 900,
    [minWidth1200]: {
      maxWidth: 1200,
    },
  },
  closeButton: libraryStyles.closeButton,
  content: (theme) => ({
    position: "relative",
    backgroundColor: theme.palette.background.default,
    mx: 2,
    my: 0.5,
    p: 0,
    borderRadius: 2.5,
    [maxWidth600]: {
      px: 1,
    },
    minHeight: "70vh",
    [largeWidthBreakPoint]: {
      minHeight: "50vh",
    },
  }),
  title: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
    justifyContent: "space-between",
  },
  arrowsText: (theme) => ({
    color: theme.palette.common.black,
  }),
  arrowButton: (theme) => ({
    color: theme.palette.common.black,
    p: 0,
  }),
  contentTextOnly: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}
